module.exports = __webpack_public_path__ + "fonts/Gilroy-Regular.woff?8e8705d069fbb9099b3a1e1d779fa5c5";